// (function(){
//   var deviceWidth = document.documentElement.clientWidth;
//   document.documentElement.style.fontSize = deviceWidth / 3.75 + 'px';
//   // 页面宽度发生变化时动态生成根字体尺寸
//   window.onresize = function () {
//     var deviceWidth = document.documentElement.clientWidth;
//     document.documentElement.style.fontSize = deviceWidth / 3.75 + 'px';
//   }
// })();
(function(){
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  if(flag){
    let deviceWidth = document.documentElement.clientWidth;
    document.documentElement.style.fontSize = deviceWidth / 3.75 + 'px';
    // 页面宽度发生变化时动态生成根字体尺寸
    window.onresize = function () {
      let deviceWidth = document.documentElement.clientWidth;
      document.documentElement.style.fontSize = deviceWidth / 3.75 + 'px';
    }
  }else{
    let deviceWidth = document.documentElement.clientWidth;
    document.documentElement.style.fontSize = deviceWidth / 14.4 + 'px';
    // 页面宽度发生变化时动态生成根字体尺寸
    window.onresize = function () {
      let deviceWidth = document.documentElement.clientWidth;
      document.documentElement.style.fontSize = deviceWidth / 14.4 + 'px';
    }  
  }
  
})();




// WEBPACK FOOTER //
// ./src/vendor/js/px2rem.js